import React, { useState, useRef, useEffect } from "react";
import "./Footer.css";
import tie_logo4 from "../Images/tie_logo4.png";
import facebookIcon from "../Images/facebook.png";
import youtubeIcon from "../Images/youtube.png";
import whatsappIcon from "../Images/whatsapp.png";
import instagramIcon from "../Images/instagram.png";
import twitterIcon from "../Images/twitter.png";
import star from "../Images/star.png";
import hand from "../Images/hands.png";
import mark from "../Images/mark.png";
import { FaLinkedin, FaSquareWhatsapp } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { ImMail } from "react-icons/im";

const Footer = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleGetStarted = (event) => {
    event.preventDefault();
    if (email.trim()) {
      setError("");
      navigate("/contactus", { state: { email } });
      setEmail("");
    } else {
      setError("Please enter a valid email address.");
    }
  };

  const collabTitleRef = useRef(null);
  const collabSubRef = useRef(null);
  const collabSub2Ref = useRef(null);
  const collabIconsRef = useRef(null);

  const footerLogoRef = useRef(null);
  const footerLeftRef = useRef(null);
  const footerNavRef = useRef(null);
  const footerContactRef = useRef(null);
  const footerLegalRef = useRef(null);

  const [visible, setVisible] = useState({
    collabTitle: false,
    collabSub: false,
    collabSub2: false,
    collabIcons: false,
    fLogo: false,
    fLeft: false,
    fNav: false,
    fContact: false,
    fLegal: false,
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (entry.target === collabTitleRef.current)
              setVisible((v) => ({ ...v, collabTitle: true }));
            if (entry.target === collabSubRef.current)
              setVisible((v) => ({ ...v, collabSub: true }));
            if (entry.target === collabSub2Ref.current)
              setVisible((v) => ({ ...v, collabSub2: true }));
            if (entry.target === collabIconsRef.current)
              setVisible((v) => ({ ...v, collabIcons: true }));

            if (entry.target === footerLogoRef.current)
              setVisible((v) => ({ ...v, fLogo: true }));
            if (entry.target === footerLeftRef.current)
              setVisible((v) => ({ ...v, fLeft: true }));
            if (entry.target === footerNavRef.current)
              setVisible((v) => ({ ...v, fNav: true }));
            if (entry.target === footerContactRef.current)
              setVisible((v) => ({ ...v, fContact: true }));
            if (entry.target === footerLegalRef.current)
              setVisible((v) => ({ ...v, fLegal: true }));
          }
        });
      },
      { threshold: 0.2 }
    );

    [
      collabTitleRef,
      collabSubRef,
      collabSub2Ref,
      collabIconsRef,
      footerLogoRef,
      footerLeftRef,
      footerNavRef,
      footerContactRef,
      footerLegalRef,
    ].forEach((ref) => {
      if (ref.current) observer.observe(ref.current);
    });
  }, []);

  return (
    <footer className="footer" aria-label="Website Footer">
      {/* SEO Hidden Icons */}
      <div className="seo-hidden">
        <img src={facebookIcon} alt="Facebook Icon" />
        <img src={youtubeIcon} alt="YouTube Icon" />
        <img src={instagramIcon} alt="Instagram Icon" />
        <img src={twitterIcon} alt="Twitter Icon" />
        <img src={whatsappIcon} alt="WhatsApp Icon" />
        <img src={tie_logo4} alt="Tech It Easy Logo SEO" />
      </div>

      <div className="collaboration-section">
        <h2
          ref={collabTitleRef}
          className={`collaboration-title service-fade ${
            visible.collabTitle ? "visible" : ""
          }`}
        >
          Want to collaborate on something great?
        </h2>

        <h3
          ref={collabSubRef}
          className={`collaboration-subtitle service-fade ${
            visible.collabSub ? "visible" : ""
          }`}
        >
          Let's Shake Hands
        </h3>

        <p
          ref={collabSub2Ref}
          className={`collaboration-subtitle1 service-fade ${
            visible.collabSub2 ? "visible" : ""
          }`}
        >
          🚀 Partner with us today and experience the power of smart technology!
        </p>

        <div className="collaboration-input">
          <form onSubmit={handleGetStarted}>
            <input
              type="email"
              placeholder="Enter your email address"
              aria-label="Email input field"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError("");
              }}
              required
            />
            <button type="submit" aria-label="Get Started Submit Button">
              Get Started
            </button>
          </form>
        </div>

        {error && <p className="email-error">{error}</p>}

        <div
          ref={collabIconsRef}
          className={`collaboration-icons service-fade ${
            visible.collabIcons ? "visible" : ""
          }`}
        >
          <div className="collaboration-metric">
            <img src={star} alt="4.9 out of 5 average rating" />
            <div className="metric-value">4.9/5</div>
            <div className="metric-label">Average Ratings</div>
          </div>

          <div className="collaboration-metric">
            <img src={hand} alt="100+ collaborations" />
            <div className="metric-value">100+</div>
            <div className="metric-label">Handshakes</div>
          </div>

          <div className="collaboration-metric">
            <img src={mark} alt="Trusted by local businesses" />
            <div className="metric-value">Trusted By</div>
            <div className="metric-label">Local Businesses</div>
          </div>
        </div>

      </div>

      <div className="sub_footer">
        <div
          ref={footerLogoRef}
          className={`footer-logo-container service-fade ${
            visible.fLogo ? "visible" : ""
          }`}
        >
          <img
            src={tie_logo4}
            alt="Tech It Easy Logo"
            className="footer-logo"
          />
          <div className="footer-logo-text">
            <h2 className="footer-company-name">Tech It Easy</h2>
            <p className="footer-tagline">Smarter - Simpler - Faster</p>
          </div>
        </div>

        <div className="footer-content">
          <div
            ref={footerLeftRef}
            className={`footer-left service-fade ${
              visible.fLeft ? "visible" : ""
            }`}
          >
            <p className="footer-description">
              Empowering local businesses to embrace digital transformation with reliable,
              easy-to-use automation solutions. We partner with you to streamline processes,
              boost productivity, and build systems that grow alongside your business.
            </p>

            <div className="footer-social-media">
              <a
                href="https://www.instagram.com/techiteasy_india/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram className="footer-icon" />
              </a>
              <a
                href="https://www.linkedin.com/company/techiteasysolutions/about/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedin className="footer-icon" />
              </a>
              <a
                href="https://wa.me/919265435410?text=Hi%20there!"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaSquareWhatsapp className="footer-icon" />
              </a>
              <a href="mailto:team@techiteasy.co.in">
                <ImMail className="footer-icon" />
              </a>
            </div>
          </div>

          <nav
            ref={footerNavRef}
            className={`footer-nav service-fade ${
              visible.fNav ? "visible" : ""
            }`}
          >
            <h3 className="footer-nav-heading">Navigation</h3>
            <Link to="/">Home</Link>
            <Link to="/saraleway">Solutions</Link>
            <Link to="/services">Services</Link>
            <Link to="/hire-dedicated-developers">Hire</Link>
            <Link to="/aboutus">About Us</Link>
          </nav>

          <div
            ref={footerContactRef}
            className={`footer-contact service-fade ${
              visible.fContact ? "visible" : ""
            }`}
          >
            <h3 className="footer-nav-heading">Contact</h3>
            <a
              href="https://wa.me/919265435410?text=Hi%20there!"
              target="_blank"
            >
              <p>+91 92654 35410</p>
            </a>
            <a href="mailto:team@techiteasy.co.in">team@techiteasy.co.in</a>
            <p>www.techiteasy.co.in</p>
          </div>
        </div>

        <div
          ref={footerLegalRef}
          className={`footer-legal service-fade ${
            visible.fLegal ? "visible" : ""
          }`}
        >
          <p>&copy; 2024. All Rights Reserved.</p>
          <div>
            <a href="/terms-conditions">User Terms & Conditions</a> |{" "}
            <a href="/privacy-policy">Privacy Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
